(function () {
  'use strict';

  function initFaq(sectionEl) {
    sectionEl.querySelectorAll('.faq-item__header').forEach(function (btn) {
      if (btn.dataset.faqBound === 'true') return;
      btn.dataset.faqBound = 'true';
      btn.addEventListener('click', function () {
        var item = btn.closest('.faq-item');
        var isOpen = item.classList.contains('is-open');

        /* Close all other open items in this section */
        sectionEl.querySelectorAll('.faq-item.is-open').forEach(function (openItem) {
          if (openItem !== item) {
            openItem.classList.remove('is-open');
            openItem.querySelector('.faq-item__header').setAttribute('aria-expanded', 'false');
          }
        });

        /* Toggle the clicked item */
        item.classList.toggle('is-open', !isOpen);
        btn.setAttribute('aria-expanded', String(!isOpen));
      });
    });
  }

  function initScrollAnimations(sectionEl) {
    var animatedEls = sectionEl.querySelectorAll('[data-animate], [data-heading-reveal]');
    if (!animatedEls.length) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -100px 0px' },
    );

    animatedEls.forEach(function (el) {
      if (el.dataset.faqObserved === 'true') return;
      el.dataset.faqObserved = 'true';
      observer.observe(el);
    });
  }

  function initFilter(sectionEl) {
    var tablist = sectionEl.querySelector('[data-faq-filter]');
    if (!tablist || tablist.dataset.faqFilterBound === 'true') return;
    tablist.dataset.faqFilterBound = 'true';

    var tabs = tablist.querySelectorAll('[data-faq-tab]');
    var list = sectionEl.querySelector('.faq-section__list');
    if (!tabs.length || !list) return;

    var reduceMotion =
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    /* On desktop the image stretches to the section height, so it changes
       whenever the content height changes. */
    var image = sectionEl.querySelector('.faq-section__image');

    /* Tween one element's height from start → end, then hand control back to
       CSS so it returns to its natural (e.g. flex-stretch) height. */
    function tweenHeight(el, startHeight, endHeight) {
      if (!el || startHeight === endHeight) return;
      var savedOverflow = el.style.overflow;

      var cleanup = function () {
        window.clearTimeout(el.faqHeightTimer);
        el.removeEventListener('transitionend', onEnd);
        el.style.height = '';
        el.style.transition = '';
        el.style.overflow = savedOverflow;
      };
      var onEnd = function (e) {
        if (e.propertyName === 'height') cleanup();
      };

      window.clearTimeout(el.faqHeightTimer);
      el.style.overflow = 'hidden';
      el.style.height = startHeight + 'px';
      void el.offsetWidth;
      el.style.transition = 'height 0.32s cubic-bezier(0.22, 1, 0.36, 1)';
      el.style.height = endHeight + 'px';
      el.addEventListener('transitionend', onEnd);
      /* Fallback in case transitionend is missed (e.g. rapid switching). */
      el.faqHeightTimer = window.setTimeout(cleanup, 420);
    }

    function activate(category, animate) {
      var doAnim = animate && !reduceMotion;
      /* Measure before the content changes so we can tween old → new heights. */
      var listStart = doAnim ? list.offsetHeight : 0;
      var imageStart = doAnim && image ? image.offsetHeight : 0;

      tabs.forEach(function (tab) {
        var on = tab.dataset.faqTab === category;
        tab.classList.toggle('is-active', on);
        tab.setAttribute('aria-selected', String(on));
      });

      list.querySelectorAll('.faq-item').forEach(function (item) {
        var show = item.dataset.faqCategory === category;
        item.classList.toggle('faq-item--hidden', !show);
        /* Collapse any open item that is being hidden. */
        if (!show && item.classList.contains('is-open')) {
          item.classList.remove('is-open');
          var header = item.querySelector('.faq-item__header');
          if (header) header.setAttribute('aria-expanded', 'false');
        }
      });

      /* Subtle content fade when switching categories. */
      list.classList.remove('faq-section__list--fade');
      void list.offsetWidth;
      list.classList.add('faq-section__list--fade');

      if (!doAnim) return;

      /* Measure both target heights before mutating inline styles, then tween
         the list and the (stretched) image together so neither snaps. */
      var listEnd = list.offsetHeight;
      var imageEnd = image ? image.offsetHeight : 0;
      tweenHeight(list, listStart, listEnd);
      if (image) tweenHeight(image, imageStart, imageEnd);
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        activate(tab.dataset.faqTab, true);
      });
    });
  }

  function initSection(sectionEl) {
    initFaq(sectionEl);
    initFilter(sectionEl);
    initScrollAnimations(sectionEl);
  }

  document.querySelectorAll('.faq-section').forEach(initSection);

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('.faq-section');
    if (el) initSection(el);
  });
})();
